import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { ApContentDSLService } from './dsl/content-dsl.service';
import { ApContentComponent } from './content.component';
import { ApContentPipe } from './content.pipe';
import { ApHeadlessContentService } from './headless/headless.service';
import { ApKeyOverridePipe } from './key-override/key-override.pipe';
import { ApContentKeyMapService } from './key-override/key-override.service';
import { ApContentService } from './content.service';

@NgModule({
    bootstrap: [],
    exports: [ApContentComponent, ApContentPipe, ApKeyOverridePipe],
    imports: [ApContentComponent, ApContentPipe, ApKeyOverridePipe],
    providers: [
        ApContentService,
        ApContentKeyMapService,
        ApContentDSLService,
        ApHeadlessContentService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ApContentModule {}
